/**
 * Offline Operations - Offline functionality for SDK
 */

import { OfflineQueue } from "../offline/queue";

export class OfflineOperations {
  private queue: OfflineQueue | null = null;

  constructor(queue?: OfflineQueue) {
    this.queue = queue || null;
  }

  /**
   * Check if offline mode is enabled
   */
  get isEnabled(): boolean {
    return this.queue !== null;
  }

  /**
   * Check if currently online
   */
  get isOnline(): boolean {
    return this.queue?.getStatus().isOnline ?? true;
  }

  /**
   * Get queue status
   */
  getStatus() {
    if (!this.queue) {
      return { isOnline: true, queuedOperations: 0, operations: [] };
    }
    return this.queue.getStatus();
  }

  /**
   * Sync all queued operations
   */
  async sync(): Promise<{ success: number; failed: number }> {
    if (!this.queue) {
      throw new Error("Offline mode is not enabled");
    }
    return await this.queue.sync();
  }

  /**
   * Clear all queued operations
   */
  clear(): void {
    if (this.queue) {
      this.queue.clear();
    }
  }

  /**
   * Get number of queued operations
   */
  get queueLength(): number {
    return this.queue?.getStatus().queuedOperations ?? 0;
  }
}
